export const PROMOTION_DEALER_INFO_ICON_SIZE = 16;

export const ARTICLE_DESKTOP_IMAGE_WIDTH = 220;
export const ARTICLE_DESKTOP_IMAGE_HEIGHT = 147;

export const ARTICLE_MOBILE_IMAGE_WIDTH = 120;
export const ARTICLE_MOBILE_IMAGE_HEIGHT = 80;
